import posthog from "posthog-js";

// posthog-js does not guarantee capture()/identify()/reset() never throw
// synchronously: identify() and reset() wrap their core logic in
// try/finally with no catch, and capture() has no top-level guard at all
// (verified against the installed SDK). identify() in particular sits in
// the setUser mutation fired from main.js's onAuthStateChanged callback on
// every app boot, which isn't itself wrapped — an uncaught throw there
// would stop the Vue app from mounting. Analytics must never be able to
// block a real user flow, so every call goes through here instead of each
// of the ~13 call sites guarding itself.
function safeCall(name, fn) {
  try {
    fn();
  } catch (err) {
    console.error(`posthog ${name} failed`, err);
  }
}

export function identify(uid) {
  safeCall("identify", () => posthog.identify(uid));
}

// the identity last given to PostHog Support: each setIdentity() makes the
// widget fetch its tickets again, and the app loads the plan several times
// per page
let supportIdentity = null;

/** proves to the Support widget who the signed-in person is, with the hash GET /user signs */
export function setSupportIdentity(uid, hash) {
  const identity = `${uid}:${hash}`;
  if (identity === supportIdentity) return;
  supportIdentity = identity;
  safeCall("setIdentity", () => posthog.setIdentity(uid, hash));
}

/**
 * session_recording.maskCapturedNetworkRequestFn: the Support widget sends the
 * identity hash in the query string of its ticket requests, and replays record
 * request URLs
 */
export function maskNetworkRequest(request) {
  if (!request?.name) return request;
  return {
    ...request,
    name: request.name.replace(
      /identity_hash=[^&]*/g,
      "identity_hash=redacted",
    ),
  };
}

// reset() also clears the Support identity inside posthog-js
export function reset() {
  supportIdentity = null;
  safeCall("reset", () => posthog.reset());
}

export function capture(event, properties) {
  safeCall("capture", () => posthog.capture(event, properties));
}
